import React from 'react'
import { Box, ImageLoader, Text } from '@usap/uicomponents'

export default function SetKitDisplay({ parentSku, style, showPartNumber = true }) {
    if (!parentSku) return null

    return (
        <Box
            pad={{ vertical: '8pt', horizontal: '12pt' }}
            style={{ border: '1px solid #D4D4D6', borderRadius: '4px' }}
        >
            <Text weight="bold" size="xsmall" color="dark-2">Included In:</Text>
            <Box direction="row">
                <Box pad="small" width="77px" height="80px">
                    <ImageLoader
                        fit="contain"
                        alt={parentSku.sku_title}
                        src={parentSku.ImageURL}
                        width="100%"
                        height="100%"
                        cloudinaryParams="w_100,h_80"
                    />
                </Box>

                <Box width="90%" pad="small" justify="center">
                    <Text size="small" color="dark-2" dangerouslySetInnerHTML={{
                        __html: parentSku.sku_title
                    }}>
                    </Text>
                    {showPartNumber && (
                        <Box direction='row'>
                            <Text size="small" color="dark-1">
                                Part Number:&nbsp;
                            </Text>
                            <Text size="small" color="dark-1" weight={700}>{parentSku.sku}</Text>
                        </Box>
                    )}
                    <Text size="small" color="dark-1">
                        Unit Price:{` $${parseFloat(parentSku?.list_price || '0').toFixed(2)}`}
                    </Text>
                </Box>
            </Box>
        </Box>
    )
}
